export const trimLastCharacter = (string, character) => {
  if (string && string.length && string.endsWith(character)) {
    return string.substring(0, string.length - 1);
  } else return string;
};
